require('./hireCardOpenCreditSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { PENDING } = require('constants/hireCardSubmitScenarios');
const {
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    PERCENTAGE_SYMBOL
} = require('constants/index');
const { catalogue, analyticsId } = require('../analytics/hireCardOpenCreditAnalytics');

class HireCardOpenCreditSuccess extends React.Component {

    buildSummary() {
        const {
            immAccount,
            immHireCardNameSelector,
            immHireCreditLimit,
            immHirePaymentMethod
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : PERCENTAGE_SYMBOL;
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
            ? paymentMethodText
            : `${paymentMethodText} ${immHirePaymentMethod.get('value')} ${paymentMethodSymbol}`;

        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-open-credit-success__summary">
                <div className="col-xs-6 hire-card-open-credit-success__summary-left-column">
                    <FormattedText
                        className="col-xs-12 hire-card-open-credit-success__summary-title"
                        value="hireCardOpenCredit-summarySelectedName"
                    />
                    <div className="col-xs-12 hire-card-open-credit-success__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-open-credit-success__summary-title"
                        value="hireCardOpenCredit-summarySelectedLimit"
                    />
                    <OneLineSymbolAmount
                        amountObject={limitObj}
                        amountObjectFormatted={formatAmountObject(limitObj, true)}
                        className="col-xs-12 hire-card-open-credit-success__summary-value"
                        language={getLanguage()}
                        trimDecimals={true}
                    />
                </div>
                <div className="col-xs-5 col-xs-offset-1">
                    <FormattedText
                        className="col-xs-12 hire-card-open-credit-success__summary-title"
                        value="cardDetails-associatedAccount"
                    />
                    <div className="col-xs-12 hire-card-open-credit-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-open-credit-success__summary-title"
                        value="hireCardOpenCredit-summaryPaymentMethod"
                    />
                    <div className="col-xs-12 hire-card-open-credit-success__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
            </div>
        );
    }

    buildTexts() {
        const { immHireCardOpenCredit, immShippingAddress } = this.props;
        let textElement;
        let titleKey;

        const pendingAnalysis = immHireCardOpenCredit.get('hiringStatus') === PENDING;

        if (pendingAnalysis) {
            titleKey = 'hireCardOpenCredit-successTitlePending';
            textElement = (
                <div className="col-xs-8 hire-card-open-credit-success__text">
                    <FormattedText value="hireCardOpenCredit-successText1Pending" />
                </div>
            );
        } else {
            const address = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);

            titleKey = 'hireCardOpenCredit-successTitleCompleted';
            textElement = (
                <div className="col-xs-8 hire-card-open-credit-success__text">
                    <FormattedText value="hireCardOpenCredit-successText1Completed" />
                    <div className="hire-card-open-credit-success__address">
                        <i className="hire-card-open-credit-success__address-icon icon icon-s-locacion" />
                        {address}
                    </div>
                    <FormattedText value="hireCardOpenCredit-successText2Completed" />
                </div>
            );
        }

        return {
            textElement,
            titleKey
        };
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const url = formatText('hireCardOpenCredit-successWarningUrl2');
        const text = !!email ? 'hireCardOpenCredit-successWarningTextSentByEmail' : 'hireCardOpenCredit-successWarningTextUpdateEmail';
        const injectedString = [
            ...(!!email ? [email] : [])
        ];

        return (
            <div className="col-xs-12">
                <OKMessage type="informative">
                    <FormattedText value="hireCardOpenCredit-successWarningText1" />
                    &nbsp;
                    <OKLink modifier="inline" target="_blank" to={url}>
                        <FormattedText value="hireCardOpenCredit-successWarningText2" />
                    </OKLink>
                    &nbsp;
                    <FormattedText value="hireCardOpenCredit-successWarningText3" />
                    <div className="hire-card-open-credit-success__message-paragraph">
                        <FormattedText value={text} injectedStrings={injectedString} />
                    </div>
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            immHireCardImageSelector,
            immHireCardOpenCredit,
            immProfile,
            processDetail
        } = this.props;
        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const { textElement, titleKey } = this.buildTexts();
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const wizardSuccessIcon = immHireCardOpenCredit.get('hiringStatus') === PENDING ? 'pending' : '';

            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hireCardOpenCredit-successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };

            content = (
                <WizardSuccess
                    iconModifier={wizardSuccessIcon}
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText(titleKey)}
                    tealium={catalogue[analyticsId.OPEN_CREDIT_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-open-credit-success">
                        <div className="row">
                            
                            <HireSuccessStepCardImage
                                className="col-xs-4 hire-card-open-credit-success__card-image"
                                immImageData={immImageData}
                            />
                            {textElement}
                        </div>
                        {summarySection}
                        <div className="row hire-card-open-credit-success__message">
                            {messageSection}
                        </div>
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

HireCardOpenCreditSuccess.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardOpenCredit: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = HireCardOpenCreditSuccess;
